import cn from 'classnames';
import { IconBasket } from 'components/Shared/Icon/themes/PP/iconBasket';
import { getQaDataAttr } from '@bygghemmait/utilities';
import styles from './styles.scss';

interface Props {
  url: string;
  quantity: number;
  className?: string;
}

export const BasketButton = ({ url, quantity, className }: Props) => (
  <a
    href={url}
    className={cn(styles.basketButton, className)}
    {...getQaDataAttr('checkout-header')}
  >
    <div className={styles.quantityBubble}>
      <div className={styles.quantity}>{quantity}</div>
    </div>
    <IconBasket className={styles.icon} />
    <span className={styles.label}>Kassa</span>
  </a>
);
